import { DragEvent, TouchEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import styles from "./TwoColumnListInput.module.css";
import { TwoColumnBlock } from "./TwoColumnListInput";
import { useIconPack } from "../../context/IconPackContext";

interface TwoColumnListItemProps {
  block: TwoColumnBlock;
  index: number;
  column: "left" | "right";
  isDragging: boolean;
  disabled: boolean;
  onDragStart: (e: DragEvent<HTMLDivElement>) => void;
  onDragEnd: () => void;
  onDragOver: (e: DragEvent<HTMLDivElement>) => void;
  onDragEnter: () => void;
  onDrop: (e: DragEvent<HTMLDivElement>) => void;
  onTouchStart: (e: TouchEvent<HTMLDivElement>) => void;
  onTouchMove: (e: TouchEvent<HTMLDivElement>) => void;
  onTouchEnd: () => void;
  itemClassName?: string;
  itemIconClassName?: string;
  itemLabelClassName?: string;
}

export default function TwoColumnListItem({
  block,
  index,
  column,
  isDragging,
  disabled,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDragEnter,
  onDrop,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  itemClassName,
  itemIconClassName,
  itemLabelClassName,
}: TwoColumnListItemProps) {
  const { getIcon } = useIconPack();

  return (
    <div
      draggable={!disabled}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDrop={onDrop}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      data-two-column-item
      data-column={column}
      data-index={index}
      className={`${itemClassName || styles.defaultItem} ${isDragging ? styles.dragging : ""}`}
      style={{
        cursor: disabled ? "default" : isDragging ? "grabbing" : "grab",
        touchAction: "none",
      }}
    >
      <div className={styles.itemLeft}>
        <DragIndicatorIcon className={styles.dragIcon} />
        <span className={styles.itemNumber}>#{index + 1}</span>
      </div>

      <div className={itemIconClassName || styles.defaultIcon}>
        <FontAwesomeIcon icon={getIcon(block.icon || "file")} />
      </div>

      <h3 className={itemLabelClassName || styles.defaultLabel}>
        {block.label}
      </h3>
    </div>
  );
}